import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormItemName } from '../../../../lib/models/Form';
import { FormItem } from '../../../../components/FormItem';
import { FormInput } from '../../../../components/FormInput';

export const ClientEmailFormItem: FC = () => {
  const { t } = useTranslation();
  const clientEmail = 'unique.formItems.clientEmail';

  return (
    <FormItem
      name={FormItemName.CLIENT_EMAIL}
      hasFeedback={true}
      rules={[
        {
          required: false,
        },

        { max: 100 },
      ]}
    >
      <FormInput label={t(`${clientEmail}.label`)} />
    </FormItem>
  );
};
